import UpgradeSubscriptionForm, {
  UpgradeSubscriptionFormFields,
  UpgradeSubscriptionFormProps
} from '@anm/components/subscription/UpgradeSubscriptionForm';
import noop from 'lodash/fp/noop';
import { FC } from 'react';

import SubscriptionModal from '../SubscriptionModal';

export type UpgradeSubscriptionModalProps = Omit<
  UpgradeSubscriptionFormProps,
  'formErrors' | 'onPurchase' | 'onSubmit'
> & {
  onPurchase: (props: UpgradeSubscriptionFormFields) => void;
  onModalClose?: () => void;
};

const UpgradeSubscriptionModal: FC<UpgradeSubscriptionModalProps> = ({
  onModalClose = noop,
  onPurchase,
  ...otherProps
}) => (
  <SubscriptionModal onModalClose={onModalClose}>
    <UpgradeSubscriptionForm onSubmit={onPurchase} {...otherProps} />
  </SubscriptionModal>
);

export default UpgradeSubscriptionModal;
